/**
 * Generic "coming soon" page for sidebar items that haven't shipped
 * yet (Marketing / DevOps / Settings). Single shared component so
 * we don't proliferate near-identical files; the sidebar still
 * renders the entry as ``soon`` so the founder knows.
 */
import { Construction } from "lucide-react";

export function StubPage({ title }: { title: string }) {
  return (
    <div className="p-6">
      <header className="mb-6">
        <h1 className="text-xl font-semibold text-slate-900">{title}</h1>
      </header>
      <div className="bg-white rounded-lg border border-slate-200 px-6 py-12 text-center">
        <Construction className="h-8 w-8 mx-auto text-slate-300" />
        <p className="mt-3 text-sm font-medium text-slate-700">
          {title} dashboard — coming in Phase 2.
        </p>
        <p className="mt-1 text-xs text-slate-500 max-w-md mx-auto">
          The endpoint plumbing for this surface lands alongside the
          page. Until then, use the backend logs + Stripe / Sentry /
          Anthropic consoles directly.
        </p>
      </div>
    </div>
  );
}
